import { useLocation } from 'wouter';
import { useAppSettings } from '@/contexts/AppSettingsContext';
import staticAppSettings from '@/constants/app-settings.json';

/** Clasă body când video-ul fix este activ pe site-ul public custom */
export const SITE_VIDEO_BACKDROP_CLASS = 'site-video-backdrop';

import { readDesignCustomCache } from '@/lib/designCustomCache';

/** @deprecated Folosește SITE_VIDEO_BACKDROP_CLASS */
export const HOME_FIXED_VIDEO_BACKDROP_CLASS = SITE_VIDEO_BACKDROP_CLASS;

export function useCustomSiteBackdrop() {
  const { settings } = useAppSettings();
  const [location] = useLocation();
  const isHome = location === '/';
  const isDashboard = location.startsWith('/dashboard');
  const designCustomFromApi = settings ? settings.design_custom === true : (staticAppSettings.design_custom === true);
  const designCustomCached = readDesignCustomCache();
  const isActive = !isDashboard && (designCustomFromApi || designCustomCached);

  return { isActive, isHome, isCustomDesign: designCustomFromApi || designCustomCached };
}

export function applySiteVideoBackdropTransparent() {
  document.documentElement.style.setProperty('background-color', 'transparent', 'important');
  document.body.style.setProperty('background-color', 'transparent', 'important');
  const layoutRoot = document.querySelector('.flex.flex-col.min-h-screen');
  const main = document.querySelector('main');
  if (layoutRoot instanceof HTMLElement) {
    layoutRoot.style.setProperty('background-color', 'transparent', 'important');
  }
  if (main instanceof HTMLElement) {
    main.style.setProperty('background-color', 'transparent', 'important');
  }
  document.querySelectorAll('section[role="banner"], .hero-section-wrapper').forEach((el) => {
    if (el instanceof HTMLElement) {
      el.style.setProperty('background-color', 'transparent', 'important');
    }
  });
  document.querySelectorAll('.bg-transparent.theme-applied').forEach((el) => {
    if (el instanceof HTMLElement) {
      el.style.setProperty('background-color', 'transparent', 'important');
    }
  });
}

export function clearSiteVideoBackdropTransparent() {
  document.documentElement.style.removeProperty('background-color');
  document.body.style.removeProperty('background-color');
  const layoutRoot = document.querySelector('.flex.flex-col.min-h-screen');
  const main = document.querySelector('main');
  if (layoutRoot instanceof HTMLElement) {
    layoutRoot.style.removeProperty('background-color');
  }
  if (main instanceof HTMLElement) {
    main.style.removeProperty('background-color');
  }
}
